export default {
    common: {
        loading: "A carregar…",
        back: "Voltar",
        save: "Guardar",
        cancel: "Cancelar",
        close: "Fechar",
        viewAll: "Ver tudo",
    },
    nav: {
        home: "Início",
        shop: "Loja",
        bulkQuote: "Cotação em volume",
        faq: "FAQ",
        research: "Pesquisa",
        about: "Sobre",
        contact: "Contacto",
    },
    header: {
        signIn: "Entrar",
        account: "Conta",
        admin: "Admin",
        logout: "Sair",
        openCart: "Abrir carrinho",
        menu: "Menu",
        language: "Idioma",
    },
    footer: {
        disclaimerTitle: "Apenas para investigação.",
        disclaimer:
            "Todos os péptidos listados neste site são vendidos estritamente para fins de investigação laboratorial in-vitro e não se destinam ao consumo humano ou veterinário. Não se destinam a diagnosticar, tratar, curar ou prevenir qualquer doença e não devem ser ingeridos, injetados, aplicados ou consumidos por humanos ou animais.",
        readFullDisclaimer: "Ler o aviso completo →",
        tagline:
            "Péptidos de investigação de elevada pureza, sintetizados no nosso laboratório parceiro. Estritamente para uso laboratorial e de investigação. Não para consumo humano.",
        purityBadge: "Pureza ≥99% verificada · testado por HPLC",
        company: "Empresa",
        legal: "Legal",
        about: "Sobre",
        research: "Pesquisa",
        shop: "Loja",
        contact: "Contacto",
        bulkQuote: "Cotação em volume",
        trackOrder: "Rastrear encomenda",
        faq: "FAQ",
        privacy: "Política de privacidade",
        gdpr: "Política RGPD",
        cookies: "Política de cookies",
        terms: "Termos e condições",
        complaints: "Procedimento de reclamações",
        copyright: "© {{year}} Nexus Peptides. Todos os direitos reservados.",
        status: "SYS.ESTADO / ONLINE · CRIO.BAY / 02 · LOTE.OK",
    },
    hero: {
        badge: "Grau de investigação · ≥99% verificado por HPLC",
        headlineLine1: "O limite",
        headlineLine2: "molecular da",
        headlineAccent: "pesquisa",
        headlineLine3: "moderna.",
        body:
            "Péptidos de alta pureza sintetizados no nosso laboratório parceiro, verificados por HPLC e espectrometria de massa de terceiros. Concebidos para laboratórios que não comprometem a integridade dos dados.",
        searchLabel: "Pesquisa de produtos",
        searchPlaceholder: "Procure entre 50+ péptidos por nome ou função…",
        searchButton: "Pesquisar",
        exploreCatalog: "Explorar catálogo",
        viewResearch: "Ver pesquisa",
        statPurity: "Pureza HPLC",
        statCompounds: "compostos",
        statColdChain: "cadeia fria",
        dragHint: "ARRASTAR · RODAR · EXPLORAR",
        tickerGuideLabel: "GRÁTIS: GUIA NEXUS PEPTIDES 101 — DESCARREGAR PDF",
        sectionCatalog: "// Catálogo · 01",
        signature: "Compostos em destaque",
        viewFullCatalog: "Ver catálogo completo",
        sectionMethod: "// Método · 02",
        methodHeading1: "Concebido para",
        methodHeading2: "dados em que",
        methodAccent: "confiar",
        methodBody:
            "Cada lote passa um protocolo de controlo de qualidade de 6 fases no nosso laboratório parceiro. Da síntese de aminoácidos a HPLC, LC-MS e ensaios microbianos — eles publicam os dados para os seus terem fundamento.",
        partnerLabSpec: "Especificações do laboratório parceiro",
        partnerLabSpecCaption: "Verificado por HPLC e espectrometria de massa de terceiros por lote",
        ctaEyebrow: "// Pronto para investigar",
        ctaHeading: "Obtenha os compostos que o seu protocolo merece.",
        ctaBrowse: "Ver catálogo",
        ctaBulk: "Pedido em volume",
    },
    chat: {
        title: "Nexus concierge",
        online: "Online · Resposta instantânea",
        toggle: "Abrir chat",
        send: "Enviar",
        placeholder: "Pergunte sobre um composto, COA, prazo…",
        disclaimer: "Assistente IA · apenas uso de investigação",
        fallbackGreeting: "Olá — em que composto ou encomenda posso ajudar?",
        rateLimited: "Atingiu o limite diário de chat. Tente amanhã ou use 'Falar com humano' abaixo.",
        errorGeneric: "O assistente está temporariamente indisponível. Tente novamente em breve.",
        back: "Voltar",
        askHuman: "Falar com humano",
        startersEyebrow: "Perguntas rápidas",
        starters: {
            bulkPricing: {
                label: "Preços por volume",
                hint: "Descontos e contas institucionais",
                prompt: "Quais são os vossos descontos por volume para uma encomenda grande?",
            },
            leadTimes: {
                label: "Prazos",
                hint: "Padrão, prioritário e à medida",
                prompt: "Quais são os vossos prazos habituais para encomendas padrão e prioritárias?",
            },
            coas: {
                label: "COAs",
                hint: "Certificado de análise por lote",
                prompt: "Como obtenho um Certificado de Análise para um produto que vou encomendar?",
            },
        },
        handoffTitle: "Falar com humano",
        handoffSubtitle: "Respondemos em 1 dia útil",
        handoffIntro: "Deixe o seu email e uma nota curta — um humano da nossa equipa responderá com a transcrição completa do chat em anexo.",
        handoffEmail: "Email profissional *",
        handoffName: "O seu nome (opcional)",
        handoffNote: "Algo específico que gostaria que respondêssemos? (opcional)",
        handoffSubmit: "Enviar para a equipa",
        handoffSending: "A enviar…",
        handoffDone: "Enviado — falamos em breve",
        handoffDoneBody: "Responderemos ao seu email em um dia útil.",
        handoffFooter: "A transcrição do chat será anexada automaticamente.",
        handoffError: "Não foi possível enviar. Tente novamente em breve.",
    },

    loyalty: {
        eyebrow: "// Programa de fidelidade",
        pts: "pts",
        worth: "Vale £{{amount}} no checkout",
        hint: "Ganhe {{earn}} pontos por cada £1 gasto. {{value}}p por ponto ao resgatar. Até {{pct}}% de desconto por encomenda.",
        redeemLabel: "Resgatar pontos",
        redeemHint: "Tem {{balance}} pts · máx {{max}} nesta encomenda (limite {{pct}}%)",
        redeemNone: "Nenhum",
        redeemMax: "Máximo",
        rowLabel: "Resgate fidelidade ({{pts}} pts)",
        earnMultiplier: "taxa de pontos",
        progressTo: "Progresso para {{label}}",
        perks: {
            bronze: "",
            silver: "Perk Silver: envio UK gratuito em todas as encomendas",
            gold: "Perks Gold: envio UK + UE gratuito + 1.25× pontos",
            platinum: "Perks Platinum: envio mundial gratuito + 1.5× pontos",
        },
    },

    process: {
        synthesis: {
            title: "Síntese em fase sólida",
            desc: "Protocolo Merrifield com proteção Fmoc em sintetizadores automáticos.",
        },
        hplc: {
            title: "HPLC + LC-MS",
            desc: "HPLC de fase inversa a 220 nm e 280 nm; massa confirmada com precisão ±1 Da.",
        },
        screening: {
            title: "Rastreio microbiano",
            desc: "Rastreio de endotoxinas e biocarga por lote.",
        },
        coldchain: {
            title: "Logística de cadeia fria",
            desc: "Armazenamento liofilizado a −20°C; contentores térmicos isolados.",
        },
    },
    shop: {
        eyebrow: "// O catálogo",
        title: "Compostos de investigação",
        intro:
            "Cada frasco acompanhado de um Certificado de Análise. Filtre por categoria ou explore a biblioteca completa. Todos os produtos são enviados liofilizados em frascos de borossilicato de 10 ml com septo de borracha.",
        searchLabel: "Pesquisa de produtos",
        searchPlaceholder: "Procure péptidos por nome, categoria ou função…",
        clear: "Limpar",
        filterAll: "Todos",
        resultsCount: "A mostrar {{count}} de {{total}} compostos{{queryPart}}",
        resultsQueryPart: " correspondentes a «{{query}}»",
        loading: "A carregar catálogo…",
        noMatchesTitle: "Sem resultados",
        noMatchesBody: "Nada encontrado para «{{query}}» em {{where}}.",
        noMatchesWhereAll: "o catálogo",
        resetFilters: "Repor filtros",
        requestTitle: "Não encontra o que precisa?",
        requestBody: "O nosso catálogo é curado, mas podemos obter quase qualquer péptido de investigação sob encomenda. Diga-nos o que procura.",
        requestCta: "Solicitar um péptido",
    },
    product: {
        purity: "Pureza",
        labPick: "Destaque",
        penBadge: "Formato caneta",
        from: "desde",
        add: "Adicionar",
        whatItDoes: "O que faz",
        selectSize: "Selecionar tamanho",
        availableSizes: "Tamanhos disponíveis",
        addToCart: "Adicionar",
        researchAdvisory: "Aviso de investigação",
        doses: "Doses",
        sizes: "{{count}} tamanhos",
        classLabel: "Categoria",
        hplc: "HPLC",
        perVial: "/ frasco",
        vialOf: "frasco de {{dose}}",
        tabOverview: "Visão geral",
        tabSpecs: "Especificações",
        tabStorage: "Armazenamento",
        highlights: "Destaques da investigação",
        sequence: "Sequência",
        molecularWeight: "Peso molecular",
        format: "Formato",
        storageBody:
            "Após reconstituição com água bacteriostática, conservar entre 2–8°C e usar até 14 dias. Evite ciclos repetidos de congelação-descongelação. Apenas para investigação in-vitro, não para uso humano ou veterinário.",
        crumbHome: "Início",
        crumbShop: "Loja",
        notFound: "Produto não encontrado",
        backToShop: "← Voltar à loja",
        coaAvailable: "COA disponível",
        downloadCoa: "Descarregar COA (PDF)",
        coldChain: "Cadeia fria",
        researchOnly: "Apenas investigação",
        viewPhoto: "Foto",
        view3D: "Modelo 3D",
        residues: "resíduos",
        dragRotate: "Arrastar · rotar",
        structureUnavailableEyebrow: "Estrutura indisponível",
        structureUnavailableTitle: "Modelo 3D indisponível para este composto",
        structureUnavailableBody: "Este composto não tem uma sequência peptídica que possamos renderizar em 3D. Volte à vista de foto para ver a imagem do produto.",
    },
    cart: {
        eyebrow: "O seu carrinho",
        countOne: "1 artigo",
        countOther: "{{count}} artigos",
        emptyTitle: "Vazio",
        emptyBody: "Ainda não há compostos no seu carrinho.",
        each: "un",
        subtotal: "Subtotal",
        bundleApplied: "Pack −{{pct}}%",
        bundleNudge: "Adicione mais 1 para −{{pct}}%",
        bundleSavings: "Poupança por pack",
        freeShipping: "Envio gratuito desbloqueado",
        towardFreeShipping: "Faltam £{{amount}} para envio gratuito",
        tierCountdown: "Faltam {{points}} pts para {{tier}}",
        tierTopReached: "Alcançou {{tier}} — o nosso nível máximo",
        checkout: "Finalizar compra →",
        keepBrowsing: "Continuar a navegar",
        requestBulkQuote: "Solicitar cotação em volume",
        remove: "Remover",
    },
    checkout: {
        eyebrow: "// Pagamento seguro",
        title: "Finalizar encomenda",
        sectionShipping: "Detalhes de envio",
        sectionPayment: "Pagamento",
        demoMode: "Modo demo",
        demoNote:
            "Esta é uma passarela de pagamento simulada. Nenhum cartão será cobrado. Use qualquer número de 16 dígitos para testar (p. ex. 4242 4242 4242 4242).",
        fullName: "Nome completo",
        email: "Email",
        address: "Morada",
        city: "Cidade",
        state: "Distrito",
        zip: "Código postal",
        country: "País",
        phone: "Telefone",
        cardNumber: "Número do cartão",
        expiry: "Validade (MM/AA)",
        cvc: "CVC",
        summaryEyebrow: "// Resumo da encomenda",
        sumBundle: "Total do carrinho",
        sumBundleSavings: "Desconto por pack",
        sumSubtotal: "Subtotal",
        sumShipping: "Envio",
        sumShippingFree: "Grátis",
        shipPolicyLabel: "Envio:",
        shipPolicyBody: "Envio gratuito para todo o mundo em encomendas acima de £{{threshold}}. Abaixo: £15 Reino Unido · £20 UE · £30 resto do mundo.",
        shipAwayFromFree: "faltam £{{amount}} para envio grátis",
        sumTax: "Impostos (est.)",
        sumTotal: "Total",
        place: "Fazer encomenda",
        placing: "A processar…",
        secureNote: "Encriptação de 256 bits · apenas demo",
        emptyTitle: "Carrinho vazio",
        emptyBody: "Adicione um composto para iniciar o pagamento.",
        browseCatalog: "Ver catálogo",
        qty: "Qtd {{n}}",
    },
    shipBanner: {
        free: "Envio gratuito para todo o mundo em encomendas acima de £150",
        regions: "£15 Reino Unido · £20 UE · £30 Resto do mundo",
        request: "Não encontra um péptido? Peça — conseguimos quase tudo",
        progress: "Faltam £{{amount}} para envio gratuito no UK",
        earned: "Envio gratuito no UK desbloqueado",
    },
    order: {
        confirmedEyebrow: "// Confirmado",
        title: "Encomenda efetuada",
        reference: "Referência",
        shippingTo: "Enviar para",
        payment: "Pagamento",
        status: "Estado",
        subtotal: "Subtotal",
        shipping: "Envio",
        shippingFree: "Grátis",
        tax: "Impostos",
        totalPaid: "Total pago",
        coldChainTitle: "Envio em cadeia fria em 24h",
        coldChainBody:
            "A sua encomenda é enviada em embalagem térmica isolada a partir da nossa câmara criogénica a −20°C. Receberá um número de seguimento por email em menos de 24 horas.",
        continueBrowsing: "Continuar a navegar",
        viewMyOrders: "Ver as minhas encomendas",
        each: "un",
    },
    trackOrder: {
        eyebrow: "// Seguimento de encomenda",
        title: "Rastreie a sua encomenda",
        subtitle: "Introduza a referência da encomenda e o email usado na compra para ver o estado em direto.",
        refLabel: "Referência da encomenda",
        refPlaceholder: "NXP-XXXXXXXX",
        emailLabel: "Email",
        emailPlaceholder: "voce@exemplo.com",
        submit: "Rastrear encomenda",
        submitting: "A procurar…",
        notFound: "Não foi encontrada nenhuma encomenda com essa referência e email. Verifique ambos e tente novamente.",
        placedOn: "Efetuada em {{date}}",
        itemsTitle: "Artigos",
        total: "Total",
        cancelled: "Esta encomenda foi cancelada.",
        stepPending: "Pendente",
        stepConfirmed: "Confirmada",
        stepProcessing: "Em processamento",
        stepShipped: "Enviada",
        stepDelivered: "Entregue",
        another: "Rastrear outra encomenda",
    },
    auth: {
        loginEyebrow: "// Entrar",
        loginTitle: "Acesso investigador",
        loginWelcomeEyebrow: "// Bem-vindo de volta",
        loginWelcomeLine1: "Aceda à",
        loginWelcomeLine2: "câmara criogénica",
        loginWelcomeBody:
            "Inicie sessão para acompanhar encomendas, descarregar Certificados de Análise e aceder a preços investigador.",
        emailLabel: "Email",
        passwordLabel: "Palavra-passe",
        submitLogin: "Entrar",
        submittingLogin: "A autenticar…",
        newHere: "Novo por aqui?",
        createAccount: "Criar conta →",
        registerEyebrow: "// Criar conta",
        registerTitle: "Registo de investigador",
        nameLabel: "Nome completo",
        passwordMin: "Palavra-passe (≥6 caracteres)",
        submitRegister: "Criar conta",
        submittingRegister: "A criar conta…",
        alreadyRegistered: "Já está registado?",
        signInLink: "Entrar →",
        registerConfirm:
            "Ao registar-se confirma que é um investigador qualificado e reconhece que todos os compostos são vendidos estritamente para investigação in-vitro — não para consumo humano ou veterinário.",
        memberBenefitsEyebrow: "// Benefícios de membro",
        memberBenefitsLine1: "Junte-se à",
        memberBenefitsLine2: "rede",
        memberBenefits: [
            "· Histórico de encomendas e arquivo de COAs",
            "· Preço investigador (-15%)",
            "· Envio prioritário em cadeia fria",
            "· Acesso antecipado a novos compostos",
        ],
        accountEyebrow: "// Painel do investigador",
        hello: "Olá, {{name}}",
        signOut: "Sair",
        ordersCount: "Encomendas",
        statStatus: "Estado",
        statSince: "Membro desde",
        admin: "Admin",
        verified: "Verificado",
        orderHistory: "Histórico de encomendas",
        noOrders: "Ainda sem encomendas.",
        rowReference: "Referência",
        reorder: "Repetir encomenda",
        reordering: "A adicionar…",
        reorderError: "Não foi possível repetir a encomenda — tente novamente.",
        viewOrder: "Ver encomenda",
        rowDate: "Data",
        rowItems: "Artigos",
        rowTotal: "Total",
    },
    faq: {
        eyebrow: "// Perguntas frequentes",
        titleLine1: "Perguntas",
        titleLine2: "frequentes",
        intro:
            "Respostas às dúvidas mais comuns sobre encomendas, envios, certificação de pureza e a nossa política de uso de investigação.",
        stillEyebrow: "// Ainda tem dúvidas?",
        stillTitle: "Fale com a equipa técnica do nosso laboratório parceiro",
        stillBody:
            "Para questões específicas de composto ou encomenda, normalmente respondemos em um dia útil.",
        contactUs: "Contactar-nos",
        items: [
            {
                q: "Para que se destinam os produtos da Nexus Peptides?",
                a: [
                    "Todos os produtos listados neste site são vendidos estritamente para fins de investigação laboratorial in-vitro. Os nossos compostos destinam-se a investigadores qualificados num ambiente laboratorial controlado e não são para consumo humano ou veterinário. Não se destinam a diagnosticar, tratar, curar ou prevenir qualquer doença.",
                ],
            },
            {
                q: "Enviam Certificado de Análise (COA) com cada encomenda?",
                a: [
                    "Sim. Cada lote é verificado independentemente por HPLC e espectrometria de massa, e existe um Certificado de Análise completo disponível por lote. Contas de investigador registadas podem aceder ao arquivo de COAs juntamente com o histórico de encomendas.",
                ],
            },
            {
                q: "Qual a pureza dos vossos compostos?",
                a: [
                    "Todos os compostos são sintetizados no nosso laboratório parceiro e libertados apenas após passar um protocolo QC de 6 fases. A pureza mediana verificada é ≥99% por HPLC de fase inversa a 220 nm e 280 nm, com massa confirmada por LC-MS.",
                ],
            },
            {
                q: "Como são enviadas e armazenadas as encomendas em trânsito?",
                a: [
                    "Os produtos são enviados liofilizados em frascos de borossilicato a partir da nossa câmara criogénica a −20°C, embalados em contentores térmicos isolados com monitorização de cadeia fria. O despacho é em 24 horas após confirmação da encomenda e um número de seguimento é enviado por email assim que a encomenda é recolhida pela transportadora.",
                ],
            },
            {
                q: "Quais são as tarifas de envio?",
                a: [
                    "Envio gratuito para todo o mundo em encomendas acima de £150. Abaixo: £15 Reino Unido, £20 UE e £30 resto do mundo. Direitos aduaneiros e impostos de importação são da responsabilidade do destinatário quando aplicável.",
                ],
            },
            {
                q: "Como devem os compostos ser armazenados à chegada?",
                a: [
                    "Conservar os frascos liofilizados a −20°C protegidos da luz. O manuseamento deve seguir as boas práticas de laboratório para reagentes de investigação. Consulte sempre a ficha técnica do composto antes de o usar em qualquer protocolo de investigação.",
                ],
            },
            {
                q: "Posso solicitar um composto que não está no catálogo?",
                a: [
                    "Sim. O nosso catálogo é curado, mas o nosso laboratório parceiro pode obter ou sintetizar quase qualquer péptido de investigação sob encomenda. Use o formulário de contacto para descrever o que precisa — pedidos em volume e personalizados recebem cotação em um dia útil.",
                ],
            },
        ],
    },
    bulk: {
        eyebrow: "// Volume e institucional",
        titleLine1: "Cotação",
        titleLine2: "em volume",
        intro:
            "Vai fazer uma encomenda para um grupo de laboratório, instituição ou programa de investigação? Diga-nos o que precisa e o nosso laboratório parceiro devolve uma cotação — com prazos claros e preços por volume — em um dia útil.",
        tiersEyebrow: "Preços por volume",
        units: "unidades",
        leadTimesEyebrow: "Prazos",
        leadTimes: {
            standard: {
                label: "Padrão — em stock",
                desc: "Envio a partir do stock em cadeia fria em 24h após confirmação do pedido.",
            },
            priority: {
                label: "Lote prioritário",
                desc: "Lote reservado, controlado e despachado em 3–5 dias úteis.",
            },
            flexible: {
                label: "Flexível / à medida",
                desc: "Síntese à medida ou reserva de lote grande — 2–4 semanas com atualizações por marco.",
            },
        },
        institutionalEyebrow: "Contas institucionais",
        institutionalBody:
            "Universidades, hospitais e CROs podem solicitar condições a 30 dias, faturação por ordem de compra e um contacto técnico dedicado no nosso laboratório parceiro.",
        formTitle: "Solicitar cotação em volume",
        name: "Nome de contacto",
        institution: "Instituição / laboratório",
        email: "Email profissional",
        phone: "Telefone",
        country: "País",
        leadTimeSelect: "Prazo preferido",
        compoundsLabel: "Compostos e quantidades",
        compoundsHint: "Adicione cada composto de que precisa, com dose opcional (p. ex. 5mg) e número de unidades.",
        compoundPlaceholder: "Nome do composto (p. ex. BPC-157)",
        dosePlaceholder: "Dose (opc.)",
        addCompound: "Adicionar composto",
        removeRow: "Remover linha",
        totalUnits: "Unidades totais",
        notes: "Notas adicionais",
        notesPlaceholder: "Datas de entrega, número de PO, detalhes de sequência à medida ou outro contexto…",
        send: "Solicitar cotação",
        sending: "A enviar…",
        success: "Pedido recebido. O nosso laboratório parceiro responderá com preços e prazos em 1 dia útil.",
        errorNoItems: "Adicione pelo menos um composto com quantidade.",
        prefilledFromCart: "Preenchido a partir do seu carrinho — ajuste as quantidades conforme necessário.",
        cartAvailable_one: "Tem 1 item no seu carrinho. Importar como ponto de partida?",
        cartAvailable_other: "Tem {{count}} itens no seu carrinho. Importar como ponto de partida?",
        loadFromCart: "Carregar do carrinho",
    },

    about: {
        eyebrow: "// Sobre a Nexus",
        titleLine1: "Procuramos",
        titleLine2: "o padrão",
        titleAccent: "que outros",
        titleLine3: "perseguem.",
        intro:
            "A Nexus Peptides é distribuidora de compostos de investigação premium. Colaboramos exclusivamente com um laboratório de síntese cujos bioquímicos não comprometem a pureza — para que os investigadores obtenham a precisão molecular necessária para publicar dados que possam defender.",
        standardsEyebrow: "// Padrões",
        standardsTitleLine1: "Quatro compromissos.",
        standardsTitleLine2: "Zero concessões.",
        commit: {
            molecular: { t: "Precisão molecular", d: "Síntese em fase sólida com proteção Fmoc, purificação RP-HPLC a 99%+." },
            verified: { t: "Verificação independente", d: "Cada lote verificado independentemente por laboratórios de química analítica acreditados." },
            coldChain: { t: "Integridade da cadeia fria", d: "Liofilizado a −80°C, enviado em contentores isolados com monitorização térmica." },
            coa: { t: "COAs transparentes", d: "Cada produto é enviado com um Certificado de Análise completo. Sem dados ocultos." },
        },
        missionEyebrow: "// Missão",
        missionTitle: "Por que existimos",
        missionBody1:
            "A investigação é tão sólida quanto os seus reagentes. Um péptido defeituoso não só desperdiça tempo — pode envenenar toda uma literatura, enviando outros laboratórios a perseguir fantasmas.",
        missionBody2:
            "A Nexus existe para eliminar essa variável. Cada frasco que sai do nosso laboratório parceiro é uma promessa silenciosa: os dados que produz são os dados que o seu composto merece.",
        statsEyebrow: "// Em números",
        stats: {
            founded: ["2019", "Fundada"],
            compounds: ["42", "Compostos ativos"],
            purity: ["≥99%", "Pureza mediana"],
            partners: ["1,2k+", "Parceiros de investigação"],
            qc: ["6", "Fases QC por lote"],
            dispatch: ["24h", "Envio cadeia fria"],
        },
        ctaTitle: "Construa a sua investigação com o padrão.",
        ctaExplore: "Ver catálogo →",
    },
    research: {
        eyebrow: "// Base de conhecimento",
        titleLine1: "Biblioteca",
        titleAccent: "de pesquisa",
        intro:
            "Literatura revista por pares e documentos técnicos internos sobre os compostos que sintetizamos. Atualizada continuamente pelo nosso conselho consultivo científico.",
        statsStudies: "Estudos indexados",
        statsCompounds: "Compostos cobertos",
        statsPartners: "Parceiros de pesquisa ativos",
        partnershipEyebrow: "// Parceria de pesquisa",
        partnershipTitle: "Colabore com o nosso laboratório parceiro",
        partnershipBody:
            "Investigadores académicos e institucionais podem candidatar-se ao nosso programa de subsídio de compostos. Projetos elegíveis recebem até 50% de desconto no preço de tabela para estudos aprovados por IRB.",
        apply: "Candidatar-se ao programa",
    },
    contact: {
        eyebrow: "// Contacte-nos",
        titleLine1: "Fale com o",
        titleLine2: "nosso laboratório parceiro.",
        intro:
            "Encomendas em volume, questões técnicas, pedidos de COA ou colaboração de investigação — a equipa científica do nosso laboratório parceiro responde em um dia útil.",
        infoEmail: "Email",
        infoPhone: "Telefone",
        infoAddress: "Morada do laboratório",
        opsEyebrow: "Operações",
        ops:
            "Segunda – Sexta · 08:00 – 18:00 PT\nEnvio de cadeia fria 24/7 para contas verificadas.",
        formTitle: "Enviar uma mensagem",
        name: "Nome",
        email: "Email",
        subject: "Assunto",
        message: "Mensagem",
        subjects: {
            general: "Pergunta geral",
            bulk: "Cotação em volume",
            coa: "Pedido de COA",
            collaboration: "Colaboração em pesquisa",
            press: "Imprensa / Media",
        },
        send: "Enviar mensagem",
        sending: "A enviar…",
        success: "Mensagem recebida. A nossa equipa responderá em 1 dia útil.",
    },
    policy: {
        last: "Última atualização:",
        backHome: "← Voltar ao início",
    },
    ageGate: {
        eyebrow: "Verificação de idade",
        titleLine1: "Tens 21 anos",
        titleLine2: "ou mais?",
        body: "Para entrar neste site, deves confirmar que tens pelo menos 21 anos e estás a aceder ao catálogo estritamente para fins de investigação laboratorial in-vitro. Os produtos da Nexus Peptides não se destinam ao consumo humano ou veterinário.",
        yes: "Sim — tenho 21 ou mais",
        no: "Não — sou menor de 21",
        storedNote: "A tua seleção é guardada localmente neste dispositivo.",
        deniedEyebrow: "Acesso restrito",
        deniedTitleLine1: "Lamentamos —",
        deniedTitleLine2: "não podes entrar.",
        deniedBody1: "Devido a restrições legais e regulamentação aplicável, deves ter ",
        deniedBodyEmphasis: "21 anos ou mais",
        deniedBody2: " para comprar ou navegar péptidos para fins de investigação. Não tens permissão para aceder a este site até cumprir o requisito mínimo de idade. Volta quando o cumprires.",
        retryPrefix: "Se chegaste a este ecrã por engano, podes ",
        retryLink: "voltar e responder de novo",
        retrySuffix: ".",
    },
};
